<template>
  <div class="FlexibleImage">

    <image-component class="FlexibleImage-image"
      v-bind="image" />

  </div>
</template>

<script>
/**
 * FlexibleImage
 * - Expands and shrinks vertically to fit its container.
 * - Container should be:
 *    display: flex;
 *    flex-grow: 1;
 *    flex-basis: 0; // set a sensible flex basis, probably above 0
 */
export default {
  name: 'FlexibleImage',

  props: {
    image: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
@import 'properties';

.FlexibleImage {
  position: relative;
  flex-grow: 1;
  display: flex;
}

.FlexibleImage-image {
  position: relative;
  display: flex;
  width: 100%;
  height: auto;
}

.FlexibleImage-image .ImageComponent-container {
  display: flex;
  flex-grow: 1;
  border: 10px solid red;
}
</style>



// WEBPACK FOOTER //
// FlexibleImage.vue?f1a5f53c